export const getPreviousFocusableElement = ({ activeElement, tabbableElements, loop = false, }) => {
    if (tabbableElements.length === 0) {
        return null;
    }
    const defaultElement = tabbableElements[tabbableElements.length - 1];
    if (activeElement === null) {
        return defaultElement;
    }
    const currentIndex = tabbableElements.indexOf(activeElement);
    if (currentIndex === -1) {
        return defaultElement;
    }
    const previousIndex = loop ? (currentIndex - 1) % tabbableElements.length : currentIndex - 1;
    if (previousIndex < 0) {
        return null;
    }
    return tabbableElements[previousIndex];
};
//# sourceMappingURL=getPreviousFocusableElement.js.map